import React, { ReactNode } from 'react'

type Props = {
  children?: ReactNode
  disabled: boolean
  onClick: () => void
}

export const PrimaryButton = ({ children, disabled, onClick }: Props) => {
  return (
    <button
      className={`w-full h-10 ${
        !disabled ? 'final-gradient' : 'disabled:bg-third'
      } rounded-2xl text-xl font-normal`}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  )
}
